import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { API_URL } from "../components/api";
import { formatDateTime } from "../../utils/dateFormat";
import { useHistory } from "react-router-dom";

import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarExportContainer,
  GridPrintExportMenuItem,
  GridFooterContainer,
  GridPagination,
} from "@mui/x-data-grid";

import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";

import AuthContext from "../context/AuthContext";
import CustomizedActions from "./BulkActions";
import Formsa, { prefetchInternetPlans } from "./editsub";
import Ping from "../components/SubscriptionPing";
import Cards from "./labels";
import ConsumptionHistory from "./consumptionHistory";
import Issues from "./issues";
import IssuesHistory from "./issuesHistory";
import TransferDays from "./TransferDays";
import ActionTable from "./ActionLogTable";
import ProgressBar from "./progress.js";

import * as XLSX from "xlsx";
import ExcelSVG from "../../ExcelSVG.svg";
import FilterSVG from "../../FilterSVG.svg";

import "./Internet.css";

/** Debounce any value (search input, checked rows, etc.) */
function useDebouncedValue(value, delay = 250) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return debounced;
}

function SubInternet(props) {
  const { user } = useContext(AuthContext);
  const history = useHistory();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const latestFetchId = useRef(0);
  const plansPrefetchStarted = useRef(false);

  const [checkedRows, setCheckedRows] = useState([]);
  const [selectedSubscriptionDetails, setSelectedSubscriptionDetails] =
    useState([]);
  const [totalSellingPrice, setTotalSellingPrice] = useState(0);
  const [totalResetQuotaPrice, setTotalResetQuotaPrice] = useState(0);

  // Search (no refresh + fast filter)
  const [searchInput, setSearchInput] = useState("");
  const debouncedSearch = useDebouncedValue(searchInput, 250);

  const [showo, setShowo] = useState(false);
  const handleshowo = () => setShowo(true);
  const handleedit = () => setShowo(false);

  const [showPing, setShowPing] = useState(false);
  const handleshowPing = () => setShowPing(true);
  const handleClosePing = () => setShowPing(false);

  const [showTransfer, setShowTransfer] = useState(false);
  const handleshowTransfer = () => setShowTransfer(true);
  const handleCloseTransfer = () => setShowTransfer(false);

  const [showLog, setShowLog] = useState(false);
  const handleShowLog = () => setShowLog(true);
  const handleCloseLog = () => setShowLog(false);

  const [subscriptionDetails, setSubscriptionDetails] = useState({
    username: "",
    password: 0,
    subId: 0,
    intSubId: 0,
    intPlanId: 0,
    site: "",
    site_name: "",
    WAP: "",
    core: "",
    planName: "",
    fullName: "",
    expDate: "",
    consumption: "",
    quotaOption: "",
    fullQuota: 0,
    connectivity: "",
    due: "",
    suffix: "",
    labelsText: "",
    paymentDate: "",
    ip: "",
    nas: "",
    cpe_mac_address: "",
  });

  const updateSubscriptionDetails = (details) => {
    setSubscriptionDetails((prev) => ({ ...prev, ...details }));
  };

  const issues = (details) => {
    setSubscriptionDetails((prev) => ({ ...prev, ...details }));
    history.push("/issues", { myProp: details.subId });
  };

  const [filters, setFilters] = useState({
    status: "",
    username: "",
    fullname_en: "",
    suffix: "",
    plan_name: "",
    points: "",
    dealer_en: "",
    due: "",
    expiration_date: "",
    payment_date: "",
    creation_date: "",
    consumption_option: "",
    connectivity: "",
    connectivity_dependent: "",
    mac_address: "",
    cpe_mac_address: "",
    ip_address: "",
    subscription_secret: "",
    uptime: "",
    labels_text: "",
  });

  const [showFilterModal, setShowFilterModal] = useState(false);
  const [gridFilterModel, setGridFilterModel] = useState({ items: [] });

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});

  const [pageSize, setPageSize] = useState(100);
  const [currentPage, setCurrentPage] = useState(0);
  const [serverTotalRows, setServerTotalRows] = useState(0);
  const [isExporting, setIsExporting] = useState(false);

  const debouncedFilters = useDebouncedValue(filters, 250);
  const debouncedGridFilterModel = useDebouncedValue(
    gridFilterModel,
    250,
  );

  const serverPaginatedTabs = [
    "active",
    "online",
    "offline",
    "expired",
    "hold",
    "inactive",
  ];

  const tabUrl = props.url || "";

  const usesServerPagination =
    tabUrl === "" || serverPaginatedTabs.includes(tabUrl);

  const requestUrl = usesServerPagination ? "" : tabUrl;

  const getSubscriptionRequestParams = (
    overrides = {},
  ) => {
    if (!usesServerPagination) {
      return {
        username: user.username,
        ...overrides,
      };
    }

    return {
      username: user.username,
      paginated: "1",
      status: tabUrl || "total",
      page: currentPage + 1,
      page_size: pageSize,
      search: debouncedSearch,
      filters: JSON.stringify(debouncedFilters),
      grid_filters: JSON.stringify(
        debouncedGridFilterModel.items || [],
      ),
      ...overrides,
    };
  };

  const fetchData = async () => {
    const fetchId = latestFetchId.current + 1;
    latestFetchId.current = fetchId;
    setLoading(true);

    try {
      const authTokens = JSON.parse(
        localStorage.getItem("authTokens"),
      );

      const response = await axios.get(
        `${API_URL}/radius/subscriptions/${requestUrl}`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: getSubscriptionRequestParams(),
        },
      );

      if (
        response.status === 200 &&
        fetchId === latestFetchId.current
      ) {
        if (usesServerPagination) {
          const payload = response.data || {};
          const rows = Array.isArray(payload.results)
            ? payload.results
            : [];

          setData(rows);
          setServerTotalRows(
            Number(payload.total) || 0,
          );
        } else {
          const rows = Array.isArray(response.data)
            ? response.data
            : [];

          setData(rows);
          setServerTotalRows(rows.length);
        }
      }
    } catch (error) {
      if (fetchId === latestFetchId.current) {
        console.error(error);
      }
    } finally {
      if (fetchId === latestFetchId.current) {
        setLoading(false);
      }
    }
  };

  const fetchAllFilteredRowsForExport = async () => {
    if (!usesServerPagination) {
      return filteredRows;
    }

    const authTokens = JSON.parse(
      localStorage.getItem("authTokens"),
    );

    const response = await axios.get(
      `${API_URL}/radius/subscriptions/${requestUrl}`,
      {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
        params: getSubscriptionRequestParams({
          export_all: "1",
          page: 1,
        }),
      },
    );

    return Array.isArray(response.data?.results)
      ? response.data.results
      : [];
  };

  const handleSubscriptionUpdated = (
    updatedSubscription,
  ) => {
    setData((currentRows) =>
      currentRows.map((row) =>
        String(row.subscription_id) ===
        String(updatedSubscription.subscription_id)
          ? updatedSubscription
          : row,
      ),
    );
  };

  // ✅ Removed refresh interval: fetch once on load / when url changes
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.url,
    user.username,
    currentPage,
    pageSize,
    debouncedSearch,
    debouncedFilters,
    debouncedGridFilterModel,
  ]);

  useEffect(() => {
    if (loading || plansPrefetchStarted.current) {
      return;
    }

    const authTokens = JSON.parse(
      localStorage.getItem("authTokens"),
    );

    if (!authTokens?.access) {
      return;
    }

    plansPrefetchStarted.current = true;
    prefetchInternetPlans(
      authTokens.access,
      user.username,
    );
  }, [loading, user.username]);

  // restore search from sessionStorage
  useEffect(() => {
    const searchValue = sessionStorage.getItem("searchSubscription");
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== "searchSubscription") sessionStorage.removeItem(key);
    });
    if (searchValue) setSearchInput(searchValue);
  }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchInput(query);
    sessionStorage.setItem("searchSubscription", query);
    setCurrentPage(0);
    handleDeselectCheckboxes();
  };

  const calculateUptime = (sessionTimeInSeconds) => {
    const sec = Number(sessionTimeInSeconds || 0);
    const hours = Math.floor(sec / 3600);
    const minutes = Math.floor((sec % 3600) / 60);
    const seconds = sec % 60;
    return `${hours} h ${minutes} m ${seconds} s`;
  };

  const getStatusCellStyle = (params) => {
    switch (params.value) {
      case "offline":
        return "status-offline";
      case "online":
        return "status-online";
      case "inactive":
        return "status-inactive";
      case "expired":
        return "status-expired";
      case "hold":
        return "status-hold";
      case "HSI":
        return "status-hsi";
      default:
        return "";
    }
  };

  const getRowId = (row) => row.subscription_id;

  const areAllRowsSelected = () => {
    const currentViewRows = paginatedRows();
    const currentViewIds = currentViewRows.map((row) => row.subscription_id);
    return currentViewIds.every((id) => checkedRows.includes(id));
  };

  const handleSelectAllCheckboxes = () => {
    const currentViewRows = paginatedRows();
    const currentViewIds = currentViewRows.map(
      (row) => row.subscription_id,
    );
    const allSelected = areAllRowsSelected();

    if (allSelected) {
      setCheckedRows((prev) =>
        prev.filter((id) => !currentViewIds.includes(id)),
      );

      setSelectedSubscriptionDetails((prev) =>
        prev.filter(
          (detail) =>
            !currentViewIds.includes(
              detail.subscriptionId,
            ),
        ),
      );
    } else {
      setCheckedRows((prev) => [
        ...prev,
        ...currentViewIds.filter(
          (id) => !prev.includes(id),
        ),
      ]);

      setSelectedSubscriptionDetails((prev) => {
        const existingIds = new Set(
          prev.map((detail) => detail.subscriptionId),
        );

        const additions = currentViewRows
          .filter(
            (row) =>
              !existingIds.has(row.subscription_id),
          )
          .map((row) => ({
            subscriptionId: row.subscription_id,
            connectivity: row.connectivity,
            planName: row.plan_name,
          }));

        return [...prev, ...additions];
      });
    }
  };

  const paginatedRows = () => {
    if (usesServerPagination) {
      return filteredRows;
    }

    const start = currentPage * pageSize;
    const end = start + pageSize;
    return filteredRows.slice(start, end);
  };

  const handleCheckboxChange = (
    event,
    subscriptionId,
    connectivity,
    planName,
  ) => {
    const checked = event.target.checked;

    setCheckedRows((prev) => {
      let updated = [...prev];
      if (checked) updated.push(subscriptionId);
      else updated = updated.filter((id) => id !== subscriptionId);
      return updated;
    });

    setSelectedSubscriptionDetails((prevDetails) => {
      if (checked) {
        return [...prevDetails, { subscriptionId, connectivity, planName }];
      }
      return prevDetails.filter((d) => d.subscriptionId !== subscriptionId);
    });
  };

  const handleDeselectCheckboxes = () => {
    setCheckedRows([]);
    setSelectedSubscriptionDetails([]);
    setTotalSellingPrice(0);
  };

  // ✅ Faster search: don’t scan Object.values(row) (very slow on large arrays)
  const SEARCH_FIELDS = useMemo(
    () => [
      "status",
      "username",
      "fullname_en",
      "suffix",
      "plan_name",
      "consumption_option",
      "labels_text",
      "ip_address",
      "mac_address",
      "cpe_mac_address",
      "site",
      "subscription_secret",
      "dealer_en",
      "connectivity",
      "wireless_access_point_name",
      "code",
    ],
    [],
  );

  // ✅ Fast filtering (memoized)
  const filteredRows = useMemo(() => {
    const words = String(debouncedSearch || "")
      .toLowerCase()
      .split(" ")
      .map((w) => w.trim())
      .filter(Boolean);

    const gridItems = Array.isArray(gridFilterModel.items)
      ? gridFilterModel.items
      : [];

    if (usesServerPagination) {
      return data || [];
    }

    return (data || []).filter((row) => {
      // Search
      const searchMatch =
        words.length === 0 ||
        words.every((word) =>
          SEARCH_FIELDS.some((f) =>
            String(row?.[f] ?? "")
              .toLowerCase()
              .includes(word),
          ),
        );

      // Modal filters
      const modalFilterMatch = Object.keys(filters).every((key) => {
        if (!filters[key]) return true;

        if (key === "connectivity_dependent") {
          const fv = String(filters[key]).toLowerCase();
          if (row.connectivity === "Fiber") {
            return String(row.code ?? "")
              .toLowerCase()
              .includes(fv);
          }
          if (row.connectivity === "Wireless") {
            return String(row.wireless_access_point_name ?? "")
              .toLowerCase()
              .includes(fv);
          }
          return false;
        }

        // uptime filter: compare against formatted uptime
        if (key === "uptime") {
          const uptime = row.latest_session_time
            ? calculateUptime(row.latest_session_time)
            : "N/A";
          return uptime
            .toLowerCase()
            .includes(String(filters[key]).toLowerCase());
        }

        return String(row?.[key] ?? "")
          .toLowerCase()
          .includes(String(filters[key]).toLowerCase());
      });

      // DataGrid filters
      const gridFilterMatch = gridItems.every((it) => {
        if (!it?.value) return true;

        const cellValue = String(row?.[it.field] ?? "");
        const filterValue = String(it.value ?? "");

        switch (it.operator) {
          case "contains":
            return cellValue.toLowerCase().includes(filterValue.toLowerCase());
          case "equals":
            return cellValue === filterValue;
          case "startsWith":
            return cellValue
              .toLowerCase()
              .startsWith(filterValue.toLowerCase());
          case "endsWith":
            return cellValue.toLowerCase().endsWith(filterValue.toLowerCase());
          default:
            return true;
        }
      });

      return searchMatch && modalFilterMatch && gridFilterMatch;
    });
  }, [
    data,
    debouncedSearch,
    filters,
    gridFilterModel,
    SEARCH_FIELDS,
    usesServerPagination,
  ]);

  useEffect(() => {
    const effectiveTotalRows = usesServerPagination
      ? serverTotalRows
      : filteredRows.length;

    const totalPages = Math.max(
      1,
      Math.ceil(effectiveTotalRows / pageSize),
    );

    if (currentPage > totalPages - 1) {
      setCurrentPage(totalPages - 1);
    }
  }, [
    filteredRows.length,
    serverTotalRows,
    pageSize,
    currentPage,
    usesServerPagination,
  ]);

  // ---- Pricing fetch (debounced to avoid lag when selecting many rows)
  const debouncedCheckedRows = useDebouncedValue(checkedRows, 300);

  const handleFetchSellingPrices = async () => {
    try {
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));

      if (debouncedCheckedRows.length === 0) {
        setTotalSellingPrice(0);
        return;
      }

      const response = await axios.post(
        `${API_URL}/radius/recharge_quote/`,
        { sub_id: debouncedCheckedRows },
        {
          headers: { Authorization: `Bearer ${authTokens.access}` },
        },
      );

      setTotalSellingPrice(
        parseFloat(response.data?.total_amount) || 0,
      );
    } catch (error) {
      console.error("Error fetching selling prices:", error);
    }
  };

  const handleFetchResetQuotaPrice = async () => {
    try {
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));

      if (debouncedCheckedRows.length === 0) {
        setTotalResetQuotaPrice(0);
        return;
      }

      const response = await axios.get(
        `${API_URL}/radius/recharge_price/`,
        {
          headers: { Authorization: `Bearer ${authTokens.access}` },
          params: {
            username: user.username,
            connectivityPlan: "Reset Quota",
          },
        },
      );

      const unitPrice =
        parseFloat(response.data?.data?.[0]?.selling_price) || 0;

      setTotalResetQuotaPrice(
        unitPrice * debouncedCheckedRows.length,
      );
    } catch (error) {
      console.error("Error fetching reset quota price:", error);
    }
  };

  useEffect(() => {
    if (debouncedCheckedRows.length > 0) handleFetchSellingPrices();
    else setTotalSellingPrice(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedCheckedRows]);

  useEffect(() => {
    if (debouncedCheckedRows.length > 0) handleFetchResetQuotaPrice();
    else setTotalResetQuotaPrice(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedCheckedRows]);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
    setCurrentPage(0);
  };

  const columns = [
    {
      field: "checkbox",
      headerName: "",
      width: 70,
      renderHeader: () => (
        <Checkbox
          indeterminate={
            paginatedRows().some((row) =>
              checkedRows.includes(row.subscription_id),
            ) && !areAllRowsSelected()
          }
          checked={
            paginatedRows().length > 0 &&
            areAllRowsSelected()
          }
          onChange={handleSelectAllCheckboxes}
        />
      ),
      renderCell: (params) => (
        <Checkbox
          className="subcheck"
          checked={checkedRows.includes(params.row.subscription_id)}
          onChange={(event) =>
            handleCheckboxChange(
              event,
              params.row.subscription_id,
              params.row.connectivity,
              params.row.plan_name,
            )
          }
        />
      ),
    },
    {
      field: "status",
      headerName: "Status",
      width: 70,
      cellClassName: (params) => getStatusCellStyle(params),
    },
    { field: "username", headerName: "Username", minWidth: 120 },
    { field: "fullname_en", headerName: "Full Name", flex: 2, minWidth: 250 },
    { field: "suffix", headerName: "Suffix", flex: 1, minWidth: 150 },
    {
      field: "plan_name",
      headerName: "Plan Name",
      flex: 1,
      minWidth: 180,
      renderCell: (params) => {
        let max = params.row.daily_limit;
        let download = params.row.pppoe_download;
        let upload = params.row.pppoe_upload;

        if (String(params.row.plan_name || "").includes("STARTER")) {
          max = params.row.monthly_limit;
          download = params.row.monthly_download;
          upload = params.row.monthly_upload;
        }

        return (
          <ProgressBar
            planName={params.row.plan_name}
            max={max}
            download={download}
            upload={upload}
          />
        );
      },
    },
    {
      field: "labels_text",
      headerName: "Labels",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => <Cards sub_id={params.row.subscription_id} />,
    },
    { field: "ip_address", headerName: "IP Address", flex: 1, minWidth: 120 },
    { field: "mac_address", headerName: "Mac Address", flex: 1, minWidth: 170 },
    {
      field: "cpe_mac_address",
      headerName: "CPE Mac Address",
      flex: 1,
      minWidth: 170,
    },
    { field: "site", headerName: "Site/Core", flex: 1, minWidth: 85 },
    { field: "fup", headerName: "FUP Status", flex: 1, minWidth: 85 },
    {
      field: "quota_option",
      headerName: "Quota Option",
      flex: 1,
      minWidth: 110,
    },
    {
      field: "is_full",
      headerName: "Full",
      flex: 1,
      minWidth: 85,
      type: "boolean",
      valueGetter: (params) => Boolean(Number(params.row.is_full)),
      valueFormatter: (params) => (params.value ? "true" : "false"),
    },
    {
      field: "subscription_secret",
      headerName: "Token",
      flex: 1,
      minWidth: 95,
    },
    { field: "dealer_en", headerName: "Reseller", flex: 1, minWidth: 120 },
    {
      field: "connectivity",
      headerName: "Connectivity",
      flex: 1,
      minWidth: 110,
    },
    {
      field: "connectivity_dependent",
      headerName: "Connectivity Info",
      flex: 1,
      minWidth: 140,
      valueGetter: (params) => {
        if (params.row.connectivity === "Fiber") return params.row.code || "";
        if (params.row.connectivity === "Wireless")
          return params.row.wireless_access_point_name || "";
        return "";
      },
      renderCell: (params) => {
        if (params.row.connectivity === "Fiber") return params.row.code || "";
        if (params.row.connectivity === "Wireless")
          return params.row.wireless_access_point_name || "";
        return "";
      },
    },
    {
      field: "consumption_option",
      headerName: "Option",
      flex: 1,
      minWidth: 110,
    },
    {
      field: "uptime",
      headerName: "Uptime",
      width: 150,
      valueGetter: (params) => {
        const t = params.row.latest_session_time; // ✅ correct field from SQL
        return t ? calculateUptime(t) : "N/A";
      },
    },
    { field: "points", headerName: "Omegas", flex: 1, minWidth: 70 },
    { field: "due", headerName: "Due", flex: 1, minWidth: 50 },
    {
      field: "payment_date",
      headerName: "Payment",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        const d = date.getDate().toString().padStart(2, "0");
        const m = (date.getMonth() + 1).toString().padStart(2, "0");
        const y = date.getFullYear();
        return `${d}-${m}-${y}`;
      },
    },
    {
      field: "expiration_date",
      headerName: "Expiry",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        const d = date.getDate().toString().padStart(2, "0");
        const m = (date.getMonth() + 1).toString().padStart(2, "0");
        const y = date.getFullYear();
        return `${d}-${m}-${y}`;
      },
    },
    {
      field: "creation_date",
      headerName: "Creation",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        const d = date.getDate().toString().padStart(2, "0");
        const m = (date.getMonth() + 1).toString().padStart(2, "0");
        const y = date.getFullYear();
        return `${d}-${m}-${y}`;
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 2,
      minWidth: 260,
      renderCell: (params) => (
        <div>
          <button
            onClick={() => {
              updateSubscriptionDetails({
                username: params.row.username,
                password: params.row.password,
                subId: params.row.subscription_id,
                intSubId: params.row.internet_subscription_id,
                intPlanId: params.row.internet_plan_id,
                site: params.row.site,
                site_name: params.row.site_name,
                WAP: params.row.wireless_access_point_name,
                core: params.row.code,
                planName: params.row.plan_name,
                fullName: params.row.fullname_en,
                expDate: params.row.expiration_date,
                paymentDate: params.row.payment_date,
                consumption: params.row.consumption_option,
                quotaOption: params.row.quota_option,
                fullQuota: Number(params.row.is_full) === 1 ? 1 : 0,
                connectivity: params.row.connectivity,
                due: params.row.due,
                suffix: params.row.suffix,
                labelsText: params.row.labels_text || "",
                cpe_mac_address: params.row.cpe_mac_address,
              });
              handleshowo();
            }}
            className="edit-client"
          >
            Edit
          </button>

          <button
            onClick={() => {
              updateSubscriptionDetails({
                subId: params.row.subscription_id,
                ip: params.row.ip_address,
                nas: params.row.nas_ip_address,
              });
              handleshowPing();
            }}
            className="edit-client"
          >
            Ping
          </button>

          <button
            onClick={() => {
              const details = {
                subId: params.row.subscription_id,
                intSubId: params.row.internet_subscription_id,
                fullName: params.row.fullname_en,
              };
              updateSubscriptionDetails(details);
              issues(details);
            }}
            className="edit-client"
          >
            History
          </button>

          <button
            onClick={() => {
              updateSubscriptionDetails({ username: params.row.username });
              handleShowLog();
            }}
            className="edit-client"
          >
            View Logs
          </button>
        </div>
      ),
    },
  ];

  const columnHeaders = {
    status: "Status",
    username: "Username",
    fullname_en: "Full Name",
    suffix: "Suffix",
    plan_name: "Plan Name",
    labels_text: "Labels",
    ip_address: "IP Address",
    mac_address: "Mac Address",
    cpe_mac_address: "CPE Mac Address",
    site: "Site/Core",
    site_name: "Site Name",
    wireless_access_point_name: "Access Point",
    code: "Core",
    subscription_secret: "Token",
    dealer_en: "Reseller",
    connectivity: "Connectivity",
    connectivity_dependent: "Connectivity Info",
    consumption_option: "Option",
    points: "Omegas",
    due: "Due",
    payment_date: "Payment",
    expiration_date: "Expiry",
    creation_date: "Creation",
    uptime: "Uptime",
  };

  const getConnectivityDependentValue = (row) => {
    if (row.connectivity === "Fiber") return row.code || "";
    if (row.connectivity === "Wireless")
      return row.wireless_access_point_name || "";
    return "";
  };

  const getUptimeValue = (row) => {
    const t = row.latest_session_time; // ✅ correct field
    return t ? calculateUptime(t) : "N/A";
  };

  const formatDateForExport = (dateValue) => formatDateTime(dateValue);

  const transformRowsForExport = (rows) => {
    return rows.map((row) => {
      const transformedRow = {};
      Object.keys(columnHeaders).forEach((field) => {
        const isVisible = columnVisibilityModel[field] !== false;
        if (!isVisible) return;

        const headerName = columnHeaders[field];

        if (field === "connectivity_dependent") {
          transformedRow[headerName] = getConnectivityDependentValue(row);
        } else if (field === "uptime") {
          transformedRow[headerName] = getUptimeValue(row);
        } else if (
          field === "payment_date" ||
          field === "expiration_date" ||
          field === "creation_date"
        ) {
          transformedRow[headerName] = formatDateForExport(row[field]);
        } else {
          transformedRow[headerName] = row[field] ?? "";
        }
      });

      return transformedRow;
    });
  };

  const handleExportToExcel = async () => {
    if (isExporting) {
      return;
    }

    setIsExporting(true);

    try {
      const exportRows =
        await fetchAllFilteredRowsForExport();

      const transformedRows =
        transformRowsForExport(exportRows);

      const worksheet =
        XLSX.utils.json_to_sheet(transformedRows);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Subscription",
      );

      XLSX.writeFile(
        workbook,
        "Subscription.xlsx",
      );
    } catch (error) {
      console.error(
        "Unable to export subscriptions:",
        error,
      );
    } finally {
      setIsExporting(false);
    }
  };


  const handleExportToCsv = async () => {
    if (isExporting) {
      return;
    }

    setIsExporting(true);

    try {
      const exportRows =
        await fetchAllFilteredRowsForExport();

      const transformedRows =
        transformRowsForExport(exportRows);

      // Match MUI's safe CSV behavior by preventing
      // spreadsheet formulas from executing from text fields.
      const safeRows = transformedRows.map((row) => {
        const safeRow = {};

        Object.entries(row).forEach(([header, value]) => {
          safeRow[header] =
            typeof value === "string" &&
            /^[=+\-@]/.test(value)
              ? `'${value}`
              : value;
        });

        return safeRow;
      });

      const worksheet =
        XLSX.utils.json_to_sheet(safeRows);

      const csvContent =
        XLSX.utils.sheet_to_csv(worksheet);

      const csvBlob = new Blob(
        ["\uFEFF", csvContent],
        {
          type: "text/csv;charset=utf-8;",
        },
      );

      const downloadUrl =
        URL.createObjectURL(csvBlob);

      const downloadLink =
        document.createElement("a");

      downloadLink.href = downloadUrl;
      downloadLink.download = "Subscription.csv";
      downloadLink.style.display = "none";

      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();

      window.setTimeout(
        () => URL.revokeObjectURL(downloadUrl),
        0,
      );
    } catch (error) {
      console.error(
        "Unable to export subscriptions as CSV:",
        error,
      );
    } finally {
      setIsExporting(false);
    }
  };

  const FullCsvExportMenuItem = ({ hideMenu }) => {
    const handleClick = async () => {
      if (typeof hideMenu === "function") {
        hideMenu();
      }

      await handleExportToCsv();
    };

    return (
      <MenuItem onClick={handleClick}>
        Download as CSV
      </MenuItem>
    );
  };

  const CustomExportButton = () => (
    <GridToolbarExportContainer
      disabled={isExporting}
    >
      <FullCsvExportMenuItem />
      <GridPrintExportMenuItem />
    </GridToolbarExportContainer>
  );
  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />

      <Button
        className="internet-toolbar-action"
        onClick={() => setShowFilterModal(true)}
        variant="outline-light"
      >
        <img
          src={FilterSVG}
          alt="Filter Icon"
          style={{ width: "18px", marginRight: "8px" }}
        />
        Filter
      </Button>

      <CustomExportButton />

      <Button
        className="internet-toolbar-action"
        onClick={handleExportToExcel}
        variant="outline-light"
        disabled={isExporting}
      >
        <img
          src={ExcelSVG}
          alt="Excel Icon"
          style={{ width: "20px", marginRight: "8px" }}
        />
        {isExporting ? "Exporting..." : "Excel"}
      </Button>

      <Button
        className="internet-toolbar-action"
        onClick={fetchData}
        variant="outline-light"
        style={{ marginLeft: 8 }}
      >
        Refresh
      </Button>
    </GridToolbarContainer>
  );

  const CustomFooter = ({ selectedCount }) => (
    <GridFooterContainer
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "12px",
        padding: "8px 16px",
      }}
    >
      <Typography
        style={{
          color: "var(--internet-table-text, white)",
        }}
      >
        {`Selected rows: ${selectedCount}`}
      </Typography>

      <GridPagination
        sx={{
          color: "var(--internet-table-text, white)",
          "& .MuiTablePagination-toolbar": {
            minHeight: "40px",
            paddingLeft: 0,
            alignItems: "center",
          },
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
            margin: "0 !important",
            lineHeight: "32px",
          },
          "& .MuiInputBase-root": {
            marginTop: "0 !important",
            marginBottom: "0 !important",
            alignSelf: "center",
          },
          "& .MuiTablePagination-select": {
            display: "flex",
            alignItems: "center",
            paddingTop: 0,
            paddingBottom: 0,
          },
          "& .MuiTablePagination-actions": {
            display: "flex",
            alignItems: "center",
            marginLeft: "8px",
          },
        }}
      />
    </GridFooterContainer>
  );

  return (
    <div className="InternetTable">
      <div className="actions">
        <CustomizedActions
          subscriptions={checkedRows}
          deselect={handleDeselectCheckboxes}
          fetch={fetchData}
          totalSellingPrice={totalSellingPrice}
          totalResetQuotaPrice={totalResetQuotaPrice}
        />

          <button
          type="button"
          className="transfer-days-action-btn"
          onClick={handleshowTransfer}
          aria-label="Open Transfer Days"
        >
          Transfer Days
        </button>

        <style>{`
          .MuiDataGrid-panelWrapper { background: var(--datagrid-panel-bg, #122632) !important; }
        `}</style>

        <input
          type="text"
          placeholder="Search..."
          value={searchInput}
          onChange={handleSearchChange}
          className="search-input"
        />
      </div>

        <div style={{ height: 520, width: "100%" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            getRowId={getRowId}
            loading={loading}
            localeText={{
              noRowsLabel: searchInput.trim()
                ? "No matching subscriptions found."
                : "No subscriptions found.",
              noResultsOverlayLabel:
                "No matching subscriptions found.",
            }}
            rowsPerPageOptions={[10, 100, 1000]}
            pagination
            paginationMode={
              usesServerPagination ? "server" : "client"
            }
            rowCount={
              usesServerPagination
                ? serverTotalRows
                : filteredRows.length
            }
            page={currentPage}
            onPageChange={(newPage) => {
              setCurrentPage(newPage);
              setCheckedRows([]);
              setSelectedSubscriptionDetails([]);
              setTotalSellingPrice(0);
            }}
            onPageSizeChange={(newPageSize) => {
              setPageSize(newPageSize);
              setCurrentPage(0);
              setCheckedRows([]);
              setSelectedSubscriptionDetails([]);
              setTotalSellingPrice(0);
            }}
            filterModel={gridFilterModel}
            onFilterModelChange={(newModel) => {
              setGridFilterModel(newModel);
              setCurrentPage(0);
              handleDeselectCheckboxes();
            }}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            components={{
              Footer: () => <CustomFooter selectedCount={checkedRows.length} />,
              Toolbar: CustomToolbar,
            }}
            disableSelectionOnClick
          />
        </div>

      {/* Edit Modal */}
      <Modal
        show={showo}
        onHide={handleedit}
        className="modal-lg subscription-edit-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Subscription</Modal.Title>
        </Modal.Header>
        <div className="Subform">
          <Formsa
            key={subscriptionDetails.intSubId}
            su={subscriptionDetails.subId}
            intsu={subscriptionDetails.intSubId}
            intpa={subscriptionDetails.intPlanId}
            usr={subscriptionDetails.username}
            full={subscriptionDetails.fullName}
            sit={subscriptionDetails.site}
            site={subscriptionDetails.site_name}
            WAP={subscriptionDetails.WAP}
            core={subscriptionDetails.core}
            cpe_mac={subscriptionDetails.cpe_mac_address}
            con={subscriptionDetails.connectivity}
            opti={subscriptionDetails.consumption}
            paymentDate={subscriptionDetails.paymentDate}
            plana={subscriptionDetails.planName}
            exp={subscriptionDetails.expDate}
            pass={subscriptionDetails.password}
            due={subscriptionDetails.due}
            quota={subscriptionDetails.quotaOption}
            isFull={subscriptionDetails.fullQuota}
            suffix={subscriptionDetails.suffix}
            labelsText={subscriptionDetails.labelsText}
            closeModal={handleedit}
            onSubscriptionUpdated={
              handleSubscriptionUpdated
            }
            fetch={fetchData}
          />
        </div>
      </Modal>

      {/* Ping Modal */}
      <Modal show={showPing} onHide={handleClosePing}>
        <Modal.Header closeButton>
          <Modal.Title>Ping</Modal.Title>
        </Modal.Header>
        <div className="Subform">
          {showPing && <Ping subscriptionId={subscriptionDetails.subId} />}
        </div>
      </Modal>

      {/* Logs Modal */}
      <Modal
        show={showLog}
        onHide={handleCloseLog}
        className="modal-xl subscription-log-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Action Logs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ActionTable subscription_username={subscriptionDetails.username} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseLog}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Transfer Modal */}
      <Modal
        show={showTransfer}
        onHide={handleCloseTransfer}
        className="modal-xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Transfer Days</Modal.Title>
        </Modal.Header>
        <div className="Subform">
          <TransferDays />
        </div>
      </Modal>

      {/* Filter Modal */}
      <Modal show={showFilterModal} onHide={() => setShowFilterModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Filters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {Object.keys(columnHeaders).map((field) => (
            <div key={field} className="filter">
              <label>{columnHeaders[field]}</label>
              <input
                type="text"
                placeholder={`Filter by ${columnHeaders[field]}`}
                value={filters[field] || ""}
                onChange={(e) => handleFilterChange(field, e.target.value)}
                className="filter-input"
              />
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFilterModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default SubInternet;
